import { useDispatch } from 'react-redux';
import { getImagenesByidFormato } from 'actions/monitoreos.actions';
import { getFileDataUri } from 'utils/file';

const generateImageUri = (base64String) => (base64String ? getFileDataUri(base64String) : null);
const obtenerNombreCompleto = (nombre, apPat, apMat) => {
  if (apMat) {
    return `${nombre} ${apPat} ${apMat}`;
  }
  return `${nombre} ${apPat}`;
};

const dummyStatus = 'done';
const dummyImgName = 'img.png';

export const useSetSignerFields = () => {
  const dispatch = useDispatch();
  return async (formatosFormulario, form) => {
    const formatos = JSON.parse(JSON.stringify(formatosFormulario));

    const { success, response } = await dispatch(
      getImagenesByidFormato({
        formato: {
          idMonitoreo: formatos.idMonitoreo,
          idFormato: formatos.idFormato
        }
      })
    );

    const firmantesImagenes = response.data?.formato?.firmantes;

    for (let i = 0; i < formatos.firmantes.length; i += 1) {
      // eslint-disable-next-line no-await-in-loop
      if (success && firmantesImagenes) {
        for (let j = 0; j < firmantesImagenes.length; j += 1) {
          // Por cada formato.firmante le asignamos su firma correspondiente
          if (formatos.firmantes[i]?.idFirmante === firmantesImagenes[j]?.idFirmante) {
            // Desestructuración para construir el nombre para aquellos que no tienen idUsuario
            const { nombre, apPaterno, apMaterno, idFirmante } = formatosFormulario.firmantes[i];
            if (firmantesImagenes[i]?.firma) {
              formatos.firmantes[i] = {
                firmante: formatos.firmantes[i]?.idUsuario,
                idFirmante,
                nombreCompletoManual:
                  formatos.firmantes[i]?.idUsuario == null
                    ? obtenerNombreCompleto(nombre, apPaterno, apMaterno)
                    : null
              };
              formatos.firmantes[i].firma = {
                fileList: [
                  {
                    uid: 1,
                    status: dummyStatus,
                    name: dummyImgName,
                    url: generateImageUri(firmantesImagenes[j]?.firma),
                    thumbUrl: generateImageUri(firmantesImagenes[j]?.firma)
                  }
                ]
              };
            }
          }
        }
      }
    }
    form.setFieldsValue({ firmas: formatos.firmantes });
  };
};
